import { render, staticRenderFns } from "./larval_site_details.vue?vue&type=template&id=d10faad8&"
import script from "./larval_site_details.vue?vue&type=script&lang=js&"
export * from "./larval_site_details.vue?vue&type=script&lang=js&"
import style0 from "./larval_site_details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports